import * as logs from "./logs";

export const common = {
    ...logs
}